import { fetchHostState } from "src/pods/realtime";
import dispatchOnMount from "src/shared/hoc/dispatchOnMount";

export default dispatchOnMount(fetchHostState)(({ children }: any) => children);
